module.exports = __webpack_public_path__ + "img/rightcalf-endo-mesomorph-female.53328e30.svg";